import type { SpatialFilterValue as CadenzaJsSpatialFilterValue } from '@disy/cadenza.js';

import { Command } from 'cadenza/api-client/workbook-commands';
import { handleRequest, subscribeToEvent } from 'cadenza/integration/post-message';
import { getStore } from 'cadenza/store/cadenza-store';
import { executeCommand } from 'cadenza/workbook/workbook-core-reducers.state';

export function handleSetFilterAction() {
  return subscribeToEvent('setFilter', async (event) => {
    const commands: Command[] = [];

    const { $spatial, ...filters } = event.detail.filter;

    const { handleSpatialFilterUpdate, handleQLFilterUpdate } = await import(
      'cadenza/integration/cadenza-api-set-filter'
    );

    commands.push(
      ...handleSpatialFilterUpdate($spatial as CadenzaJsSpatialFilterValue | undefined /* Asserted by Cadenza JS */),
      ...handleQLFilterUpdate(filters),
    );

    handleRequest(
      event,
      getStore()
        .dispatch(executeCommand(Command.COMPOSITE_COMMAND({ commands })))
        .unwrap()
        .then(() => {}),
    );
  });
}
